module.exports = __webpack_public_path__ + "img/ic-cancel.e2c39bb1.svg";